import { ApiRoutes, ForceEmailSendRequest, ForceEmailSendResponse } from 'types';
import { axiosInstance } from './axiosInstance';
import { getApiUrl } from './helpers';

export async function forceEmailSend(body: ForceEmailSendRequest) {
  const { data } = await axiosInstance.post<ForceEmailSendResponse>(
    getApiUrl({ path: ApiRoutes.ForceEmailSend }),
    body
  );
  return data;
}
